import React, { useMemo, useRef, useState } from "react";
import { getFormattedNumber } from "../utils/textUtils";
import Modal from "react-bootstrap/Modal";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { useReactToPrint } from "react-to-print";
import { deficitReport } from "../../services";

const selectedItemObj = {
    uuid: "",
    title: "",
    currentStockBoxQuantity: "",
    quantity: "",
    reorderPoint: "",
    orderNumber: "",
    itemTitle: "",
    itemQuantity: "",
    customerName: "",
    packUnitTitle: "",
};

const DeficitReport = ({ resPacket, warehouse }) => {
    const [show, setShow] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemList, setItemList] = useState([]);
    const componentRef = useRef();
    const getPurchaseReportByItemId = (item) => {
        setSelectedItem(item.title);
        var request = {
            warehouseId: warehouse?.value || "",
            itemId: item.uuid,
        };
        deficitReport(request).then((res) => {
            if (res.responsePacket) {
                setItemList(res.responsePacket);
                setShow(true);
            }
        });
    };

    const getTotal = (list) => {
        let total = list.reduce((acc, crr) => {
            const installmentAmount = parseFloat(crr.itemQuantity);
            if (!isNaN(installmentAmount)) {
                return acc + installmentAmount;
            } else {
                return acc;
            }
        }, 0);
        return total;
    };

    const handleReactToPrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const handlePrint = () => {
        setTimeout(() => {
            handleReactToPrint();
        }, 1000);
    };

    const total = useMemo(() => {
        let acc = { unitQty: {}, unitAmount: {}, totalUnitQty: 0, totalUnitAmount: 0, totalAmountWithTax: 0 }
        for (let i = 0; i < itemList.length; i++) {
            const cur = itemList[i]
            // Calculation for Quantity
            if (acc.unitQty[cur.unitName]) {
                acc.unitQty[cur.unitName] += parseFloat(cur.itemQuantity)
                acc.totalUnitQty += parseFloat(cur.itemQuantity)
            } else {
                acc.unitQty[cur.unitName] = parseFloat(cur.itemQuantity)
                acc.totalUnitQty += parseFloat(cur.itemQuantity)
            }

            // Calculation for Amount
            if (acc.unitAmount[cur.unitName]) {
                acc.unitAmount[cur.unitName] += cur.amount
                acc.totalUnitAmount += cur.amount
                acc.totalAmountWithTax = acc.totalAmountWithTax + cur.amount + (Number(cur.amount) * Number(cur.taxRate)) / 100
            } else {
                acc.unitAmount[cur.unitName] = cur.amount
                acc.totalUnitAmount += cur.amount
                acc.totalAmountWithTax = acc.totalAmountWithTax + cur.amount + (Number(cur.amount) * Number(cur.taxRate)) / 100
            }

        }
        return acc
    }, [itemList])

    const getCalculatedQty = (data, type) => {
        const baseValue = parseFloat(data.unitConversion?.split(":")[1].trim())
        let total = 0;
        data.packagingDetails?.map((item) => {
            if (item?.isPackUnit) {
                total = total + parseFloat(item[type]);
            } else {
                total = total + (parseFloat(item[type]) / baseValue);
            }
        })
        return total.toFixed(2);
    }
    
    return resPacket?.length > 0 ? (
        <>
        <div className="customTable"  id="scroll">
            <table className="customTable w-100">
                <thead className="fixed-thead">
                    <tr className="text-right">
                        <td>SNO.</td>
                        <td className="text-left">TITLE</td>
                        <td className="text-left">CATEGORY </td>
                        <td>PACK UNIT</td>
                        <td>CURRENT STOCK</td>
                        <td>REQUIRED QUANTITY</td>
                        <td>DIFFERENCE</td>
                        {/* <td>REQUESTED PACK QUANTITY</td>
                        <td>PACK UNIT</td>
                        <td>CURRENT PACK STOCK</td>
                        <td>PACK UNIT</td>
                        <td>REQUESTED OPEN QUANTITY</td>
                        <td>OPEN UNIT</td>
                        <td>CURRENT OPEN STOCK</td>
                        <td>OPEN UNIT</td> */}
                    </tr>
                </thead>
                <tbody className="body-scroll-custom">
                    {resPacket?.map((row, i) => (
                        <tr key={i}>
                            <td className="text-right">{i + 1}</td>
                            <td
                                className="text-left item-title-blue cursor-pointer"
                                onClick={() => getPurchaseReportByItemId(row)}
                            >
                                {row.itemTitle}
                            </td>
                            <td className="text-left">{row?.category}</td>
                            <td className="text-right">{row.unitConversionTitle?.split(":")[0].trim()}</td>
                            <td className="text-right">{getCalculatedQty(row, "currentStockQuantity")}</td>
                            <td className="text-right">{getCalculatedQty(row, "requestQuantity")}</td>
                            <td className={`text-right ${getCalculatedQty(row, "currentStockQuantity") - getCalculatedQty(row, "requestQuantity") < 0 ? 'text-danger' : ''}`}>
                                {(getCalculatedQty(row, "currentStockQuantity") - getCalculatedQty(row, "requestQuantity")).toFixed(2)}
                            </td>
                            {/* <td>{ row?.packagingDetails.map((item, i) => item?.isPackUnit && <div key={i}>{item.requestQuantity}</div>)}
                            </td>
                            <td> { row?.packagingDetails.map((item, i) => item?.isPackUnit && <div key={i}>{item.unitTitle}</div>)}
                            </td>
                            <td>{ row?.packagingDetails.map((item, i) => item?.isPackUnit && <div key={i}>{item.currentStockQuantity}</div>)}
                            </td>
                            <td> { row?.packagingDetails.map((item, i) => item?.isPackUnit && <div key={i}>{item.unitTitle}</div>)}
                            </td>
                            <td>{ row?.packagingDetails.map((item, i) => !item.isPackUnit && <div key={i}>{parseFloat(item.requestQuantity).toFixed(3)}</div>)}
                            </td>
                            <td> { row?.packagingDetails.map((item, i) => !item.isPackUnit && <div key={i}>{item.unitTitle}</div>)}
                            </td>
                            <td>{ row?.packagingDetails.map((item, i) => !item.isPackUnit && <div key={i}>{parseInt(item.currentStockQuantity).toFixed(3)}</div>)}
                            </td>
                            <td> { row?.packagingDetails.map((item, i) => !item.isPackUnit && <div key={i}>{item.unitTitle}</div>)}
                            </td> */}
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
            {show && (
                <Modal show={show} onHide={() => setShow(false)} size="xl">
                    <div className="d-flex justify-content-between mt-3 mx-4">
                        <h3 className="font-size-20">Order Quantity</h3>
                        {/* <button
                            className="btn hoverBtn p-1"
                            onClick={handlePrint}
                        >
                            <LocalPrintshopOutlinedIcon style={{ fontSize: "22px" }} />
                        </button> */}
                    </div>
                    <Modal.Body>
                        <div
                            className="custom-table-div standardTable"
                            ref={componentRef}
                            id="pdf"
                            style={{
                                width: "100%",
                                margin: "15px",
                                color: "black",
                            }}
                        >
                            <div className="row p-3 align-items-center">
                                <div className="col-5">
                                    <h2 className="font-size-18 font-weight-bold">{`${itemList[0].itemTitle}`}</h2>
                                </div>
                            </div>
                            <hr style={{ backgroundColor: "#ececec" }} />
                            <div>
                                {itemList?.length > 0 ? (
                                    <>
                                        <table className=" table">
                                            <thead>
                                                <tr>
                                                    <th>SR NO.</th>
                                                    <th>ORDER NUMBER</th>
                                                    <th>CUSTOMER NAME</th>
                                                    <th>ITEM QUANTITY</th>
                                                    <th>UNIT</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {itemList &&
                                                    itemList?.map((a, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td>
                                                                {a.orderNumber}
                                                            </td>
                                                            <td>
                                                                {a.customerName}
                                                            </td>
                                                            <td>
                                                                {a.itemQuantity}
                                                            </td>
                                                            <td>
                                                                {a.unitName}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                <tr>
                                                    <td className="border-bottom"><b>Total</b></td>
                                                    <td className="border-bottom" colSpan={2}></td>
                                                    <td className="border-bottom">
                                                        {Object.keys(total["unitQty"]).map((unit, i) => {
                                                            return (
                                                                <>
                                                                    <div key={"unitQty" + i} className=" pl-0 border-top-grey">
                                                                        <b>{`${parseFloat(total["unitQty"][unit]).toFixed(2)} ${unit}`}</b>
                                                                    </div>
                                                                </>
                                                            );
                                                        })}
                                                    </td>
                                                    <td className="border-bottom"></td>
                                                    <td className="border-bottom"></td>
                                                    {/* <td className="border-bottom">
                                                        {Object.keys(total["unitAmount"]).map((key, i) => {
                                                            return (
                                                                <>
                                                                    <div key={"unitAmount" + i} className="border-top-grey">
                                                                        <b>{parseFloat(total["unitAmount"][key]).toFixed(2)}</b>
                                                                    </div>
                                                                </>
                                                            );
                                                        })}
                                                    </td> */}
                                                    {/* <td className="border-bottom"></td> */}
                                                </tr>
                                                {/* <tr>
                                                    <td
                                                        className="border-bottom"
                                                        colSpan={4}
                                                    ></td>
                                                </tr> */}
                                                {/* <tr>
                                                    <td className="border-bottom" colSpan={2}>
                                                        <b>Total</b>
                                                    </td>
                                                    <td className="border-bottom">
                                                        {getTotal(itemList).toFixed(2)}
                                                    </td>
                                                    <td><b>{total["totalUnitQty"].toFixed(2)}</b> </td>
                                                    <td>25</td>
                                                    <td className="border-bottom"></td>
                                                    <td><b>{total["totalUnitAmount"].toFixed(2)}</b></td>
                                                    <td><b>{total["totalAmountWithTax"].toFixed(2)}</b></td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </>
                                ) : (
                                    <>No Record found</>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    ) : (
        <>No Record found.</>
    );
};

export default DeficitReport;
